(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primitra-eink-lab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new WeakSet();

    const parseRows = (raw) => {
      const rows = String(raw || '').split(/\r?\n/).map((row) => row.replace(/[^01]/g, '')).filter((row) => row.length > 0);
      const bits = [];
      rows.forEach((row) => {
        for (const char of row) bits.push(char === '1');
      });
      // 归一化为严格 144 位（12×12）
      while (bits.length < 144) bits.push(false);
      return bits.slice(0, 144);
    };

    const mountLab = (root) => {
      if (!root || mounted.has(root)) return;

      const lab = root.querySelector('[data-eink-lab]');
      const grid = lab?.querySelector('[data-lab-grid]');
      if (!lab || !grid) return;

      // 图案库：从 pattern blocks 读取（标题、说明、144 位数据）
      const patterns = [];
      lab.querySelectorAll('[data-pattern-choice]').forEach((button) => {
        const blockId = button.dataset.patternChoice;
        const source = root.querySelector(`[data-lab-pattern-source="${blockId}"]`);
        const rows = source ? source.textContent : '';
        patterns.push({
          id: blockId,
          button,
          title: source?.dataset.title || button.textContent.trim(),
          description: source?.dataset.description || '',
          iconSource: source?.dataset.emotionIcon || '',
          bits: parseRows(rows),
        });
      });
      if (patterns.length === 0) return;

      // 从安静到强烈的情绪语境顺序；找不到对应图标时仍按现有预设顺序回退。
      const moodPatternOrder = ['clam', 'relief', 'reflect', 'joy', 'pressure'];
      const moodPatterns = moodPatternOrder
        .map((icon) => patterns.find((pattern) => pattern.iconSource.includes(`primitra-emotion-${icon}.svg`)))
        .filter(Boolean);
      const moodPatternForValue = (value) => {
        const available = moodPatterns.length ? moodPatterns : patterns;
        const index = Math.min(available.length - 1, Math.floor((value / 101) * available.length));
        return available[index];
      };

      const screen = lab.querySelector('[data-lab-screen]');
      const title = lab.querySelector('[data-lab-title]');
      const text = lab.querySelector('[data-lab-text]');
      const editorGrid = lab.querySelector('[data-lab-editor]');
      const status = lab.querySelector('[data-lab-status]');
      const moodRange = lab.querySelector('[data-lab-mood-range]');
      const moodName = lab.querySelector('[data-lab-mood-name]');
      const nextButton = lab.querySelector('[data-lab-next]');
      const details = lab.querySelector('[data-lab-editor-details]');
      const imageInput = lab.querySelector('[data-lab-image-input]');
      const imageCanvas = lab.querySelector('[data-lab-image-canvas]');

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const { signal } = controller;

      let currentId = lab.dataset.defaultBlock || patterns[0].id;
      if (!patterns.some((pattern) => pattern.id === currentId)) currentId = patterns[0].id;
      let customBits = null;
      let uploadedImageData = null;
      let presetImageData = null;
      const customTitle = root.dataset.customTitle || 'YOURS';
      const customDescription = root.dataset.customDescription || 'Your drawing, applied to the badge.';

      const activeBits = () => customBits || (patterns.find((pattern) => pattern.id === currentId) || patterns[0]).bits;

      const refreshScreen = () => {
        if (reduceMotion.matches || !screen) return;
        screen.classList.remove('is-refreshing');
        void screen.offsetWidth;
        screen.classList.add('is-refreshing');
      };

      const announce = (message) => {
        if (!status) return;
        status.textContent = message;
      };

      const paintGrid = () => {
        const bits = activeBits();
        const cells = grid.querySelectorAll('i');
        if (cells.length !== bits.length) {
          grid.innerHTML = bits.map((on) => `<i${on ? ' class="on"' : ''}></i>`).join('');
        } else {
          bits.forEach((on, index) => cells[index].classList.toggle('on', on));
        }
      };

      const paintEditor = () => {
        if (!editorGrid) return;
        const bits = activeBits();
        const buttons = editorGrid.querySelectorAll('button');
        if (buttons.length !== bits.length) {
          editorGrid.innerHTML = bits
            .map(
              (on, index) =>
                `<button type="button" data-editor-pixel="${index}" aria-pressed="${on}" aria-label="Pixel row ${Math.floor(index / 12) + 1}, column ${(index % 12) + 1}"></button>`
            )
            .join('');
        } else {
          bits.forEach((on, index) => {
            const button = buttons[index];
            button.classList.toggle('on', on);
            button.setAttribute('aria-pressed', String(on));
          });
        }
      };

      const updateReadout = () => {
        if (uploadedImageData) {
          if (title) title.textContent = 'IMAGE';
          if (text) text.textContent = 'Your image converted to a 200 × 200 e-ink display.';
          return;
        }
        if (customBits) {
          if (title) title.textContent = customTitle;
          if (text) text.textContent = customDescription;
        } else {
          const pattern = patterns.find((item) => item.id === currentId) || patterns[0];
          if (title) title.textContent = pattern.title;
          if (text) text.textContent = pattern.description;
        }
      };

      const updatePatternButtons = () => {
        patterns.forEach((pattern) => {
          const selected = pattern.id === currentId && !customBits && !uploadedImageData;
          pattern.button.classList.toggle('is-selected', selected);
          pattern.button.setAttribute('aria-pressed', String(selected));
        });
      };

      const render = () => {
        paintGrid();
        paintEditor();
        updateReadout();
        updatePatternButtons();
        const imageData = uploadedImageData || presetImageData;
        if (imageData) {
          renderImageCanvas(imageData);
        } else {
          grid.hidden = false;
          if (imageCanvas) imageCanvas.hidden = true;
        }
      };

      const choosePattern = (id) => {
        currentId = id;
        customBits = null;
        uploadedImageData = null;
        presetImageData = null;
        render();
        refreshScreen();
        announce('');
        const pattern = patterns.find((item) => item.id === id);
        if (!pattern?.iconSource) return;
        assetUrlToImageData(pattern.iconSource)
          .then((imageData) => {
            if (currentId !== id || customBits || uploadedImageData) return;
            presetImageData = imageData;
            render();
            refreshScreen();
          })
          .catch(() => announce('This emotion icon could not be converted.'));
      };

      const applyCustom = () => {
        uploadedImageData = null;
        presetImageData = null;
        if (!customBits) customBits = activeBits().slice();
        render();
        refreshScreen();
        announce('Custom drawing applied.');
      };

      const clearCustom = () => {
        uploadedImageData = null;
        presetImageData = null;
        customBits = Array(144).fill(false);
        render();
        refreshScreen();
        announce('Grid cleared.');
      };

      const buildEinkToneMap = (imageData) => {
        const { data, width, height } = imageData;
        const histogram = new Uint32Array(256);
        const count = width * height;

        for (let index = 0; index < count; index += 1) {
          const source = index * 4;
          const alpha = data[source + 3] / 255;
          const red = data[source] * alpha + 242 * (1 - alpha);
          const green = data[source + 1] * alpha + 241 * (1 - alpha);
          const blue = data[source + 2] * alpha + 232 * (1 - alpha);
          const luminance = Math.round(0.299 * red + 0.587 * green + 0.114 * blue);
          histogram[luminance] += 1;
        }

        const percentile = (ratio) => {
          const target = Math.max(0, Math.floor((count - 1) * ratio));
          let accumulated = 0;
          for (let value = 0; value < histogram.length; value += 1) {
            accumulated += histogram[value];
            if (accumulated > target) return value;
          }
          return 255;
        };

        const sourceBlackPoint = percentile(0.02);
        const sourceWhitePoint = percentile(0.98);
        const sourceRange = sourceWhitePoint - sourceBlackPoint;
        if (sourceRange < 48) return { blackPoint: 0, range: 255 };
        return { blackPoint: sourceBlackPoint, range: sourceRange };
      };

      const ditherImageData = (imageData) => {
        const { data, width, height } = imageData;
        const count = width * height;
        const toneMap = buildEinkToneMap(imageData);
        const luminanceValues = new Float32Array(count);
        const output = new Uint8ClampedArray(data.length);

        for (let index = 0; index < count; index += 1) {
          const source = index * 4;
          const alpha = data[source + 3] / 255;
          const red = data[source] * alpha + 242 * (1 - alpha);
          const green = data[source + 1] * alpha + 241 * (1 - alpha);
          const blue = data[source + 2] * alpha + 232 * (1 - alpha);
          const luminance = 0.299 * red + 0.587 * green + 0.114 * blue;
          const normalized = Math.min(255, Math.max(0, (luminance - toneMap.blackPoint) * 255 / toneMap.range));
          luminanceValues[index] = normalized;
        }

        const spreadError = (index, atkinsonError) => {
          luminanceValues[index] += atkinsonError;
        };

        for (let y = 0; y < height; y += 1) {
          const leftToRight = y % 2 === 0;
          const start = leftToRight ? 0 : width - 1;
          const end = leftToRight ? width : -1;
          const step = leftToRight ? 1 : -1;

          for (let x = start; x !== end; x += step) {
            const index = y * width + x;
            const current = Math.min(255, Math.max(0, luminanceValues[index]));
            const isPaper = current >= 128;
            const error = current - (isPaper ? 255 : 0);
            const atkinsonError = error / 8;
            const outputIndex = index * 4;
            output[outputIndex] = isPaper ? 242 : 23;
            output[outputIndex + 1] = isPaper ? 241 : 24;
            output[outputIndex + 2] = isPaper ? 232 : 21;
            output[outputIndex + 3] = 255;

            const forward = x + step;
            const forwardTwo = x + step * 2;
            const backward = x - step;
            if (forward >= 0 && forward < width) spreadError(y * width + forward, atkinsonError);
            if (forwardTwo >= 0 && forwardTwo < width) spreadError(y * width + forwardTwo, atkinsonError);
            if (y + 1 < height) {
              if (backward >= 0 && backward < width) spreadError((y + 1) * width + backward, atkinsonError);
              spreadError((y + 1) * width + x, atkinsonError);
              if (forward >= 0 && forward < width) spreadError((y + 1) * width + forward, atkinsonError);
            }
            if (y + 2 < height) {
              spreadError((y + 2) * width + x, atkinsonError);
            }
          }
        }

        return new ImageData(output, width, height);
      };

      const findInkBounds = (imageData) => {
        const { data, width, height } = imageData;
        let left = width;
        let top = height;
        let right = -1;
        let bottom = -1;

        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const index = (y * width + x) * 4;
            const alpha = data[index + 3] / 255;
            if (alpha < 0.03) continue;

            const red = data[index] * alpha + 242 * (1 - alpha);
            const green = data[index + 1] * alpha + 241 * (1 - alpha);
            const blue = data[index + 2] * alpha + 232 * (1 - alpha);
            const luminance = 0.299 * red + 0.587 * green + 0.114 * blue;
            if (luminance >= 220) continue;

            left = Math.min(left, x);
            top = Math.min(top, y);
            right = Math.max(right, x);
            bottom = Math.max(bottom, y);
          }
        }

        if (right < left || bottom < top) return null;
        return { left, top, width: right - left + 1, height: bottom - top + 1 };
      };

      const hasDarkCanvasEdge = (imageData) => {
        const { data, width, height } = imageData;
        const inset = Math.max(1, Math.floor(Math.min(width, height) * 0.02));
        const samples = [
          [inset, inset],
          [width - inset - 1, inset],
          [inset, height - inset - 1],
          [width - inset - 1, height - inset - 1],
        ];
        let darkSamples = 0;

        samples.forEach(([x, y]) => {
          const index = (y * width + x) * 4;
          const alpha = data[index + 3] / 255;
          const red = data[index] * alpha + 242 * (1 - alpha);
          const green = data[index + 1] * alpha + 241 * (1 - alpha);
          const blue = data[index + 2] * alpha + 232 * (1 - alpha);
          const luminance = 0.299 * red + 0.587 * green + 0.114 * blue;
          if (luminance < 128) darkSamples += 1;
        });

        return darkSamples >= 3;
      };

      const imageFileToImageData = async (file) => {
        let image;
        // Safari 等浏览器对 SVG 的 createImageBitmap 支持不完整；SVG 使用原生 Image 解码，
        // 再走与上传图片相同的裁切与 200 × 200 墨水屏转换流程。
        if ('createImageBitmap' in window && file.type !== 'image/svg+xml') {
          image = await createImageBitmap(file);
        } else {
          const objectUrl = URL.createObjectURL(file);
          image = await new Promise((resolve, reject) => {
            const fallbackImage = new Image();
            fallbackImage.onload = () => {
              URL.revokeObjectURL(objectUrl);
              resolve(fallbackImage);
            };
            fallbackImage.onerror = () => {
              URL.revokeObjectURL(objectUrl);
              reject(new Error('Image decoding failed.'));
            };
            fallbackImage.src = objectUrl;
          });
        }

        const sourceWidth = image.width;
        const sourceHeight = image.height;
        const sourceCanvas = document.createElement('canvas');
        sourceCanvas.width = sourceWidth;
        sourceCanvas.height = sourceHeight;
        const sourceContext = sourceCanvas.getContext('2d', { willReadFrequently: true });
        if (!sourceContext) throw new Error('Source canvas is unavailable.');
        sourceContext.drawImage(image, 0, 0);
        const sourceData = sourceContext.getImageData(0, 0, sourceWidth, sourceHeight);
        const bounds = findInkBounds(sourceData);
        const useInkBackdrop = hasDarkCanvasEdge(sourceData);
        const crop = bounds || { left: 0, top: 0, width: sourceWidth, height: sourceHeight };
        const contentPadding = Math.max(crop.width, crop.height) * 0.04;
        const cropLeft = Math.max(0, crop.left - contentPadding);
        const cropTop = Math.max(0, crop.top - contentPadding);
        const cropRight = Math.min(sourceWidth, crop.left + crop.width + contentPadding);
        const cropBottom = Math.min(sourceHeight, crop.top + crop.height + contentPadding);
        const cropWidth = cropRight - cropLeft;
        const cropHeight = cropBottom - cropTop;
        const inset = 16;
        const targetSize = 200;
        const scale = Math.min((targetSize - inset * 2) / cropWidth, (targetSize - inset * 2) / cropHeight);
        const drawWidth = cropWidth * scale;
        const drawHeight = cropHeight * scale;
        const canvas = document.createElement('canvas');
        canvas.width = targetSize;
        canvas.height = targetSize;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) throw new Error('Canvas is unavailable.');
        context.imageSmoothingEnabled = true;
        context.fillStyle = useInkBackdrop ? 'rgb(23, 24, 21)' : 'rgb(242, 241, 232)';
        context.fillRect(0, 0, targetSize, targetSize);
        context.drawImage(
          image,
          cropLeft,
          cropTop,
          cropWidth,
          cropHeight,
          (targetSize - drawWidth) / 2,
          (targetSize - drawHeight) / 2,
          drawWidth,
          drawHeight
        );
        image.close?.();
        return ditherImageData(context.getImageData(0, 0, targetSize, targetSize));
      };

      const assetUrlToImageData = async (assetUrl) => {
        const response = await fetch(assetUrl);
        if (!response.ok) throw new Error('Emotion icon could not be loaded.');
        return imageFileToImageData(await response.blob());
      };

      const renderImageCanvas = (imageData) => {
        if (!imageCanvas) return;
        const context = imageCanvas.getContext('2d');
        if (!context) return;
        const raster = document.createElement('canvas');
        raster.width = 200;
        raster.height = 200;
        const rasterContext = raster.getContext('2d');
        if (!rasterContext) return;
        rasterContext.putImageData(imageData, 0, 0);
        context.clearRect(0, 0, 200, 200);
        context.save();
        context.beginPath();
        context.arc(100, 100, 100, 0, Math.PI * 2);
        context.clip();
        context.drawImage(raster, 0, 0);
        context.restore();
        imageCanvas.hidden = false;
        grid.hidden = true;
      };

      // 事件：图案选择 / 下一图案
      patterns.forEach((pattern) => {
        pattern.button.addEventListener('click', () => choosePattern(pattern.id), { signal });
      });

      nextButton?.addEventListener(
        'click',
        () => {
          const index = patterns.findIndex((pattern) => pattern.id === currentId);
          const next = patterns[(index + 1) % patterns.length];
          choosePattern(next.id);
        },
        { signal }
      );

      // 事件：编辑器像素切换（事件委托）
      editorGrid?.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-editor-pixel]');
          if (!button) return;
          const index = Number(button.dataset.editorPixel);
          if (!Number.isInteger(index) || index < 0 || index > 143) return;
          if (!customBits) customBits = activeBits().slice();
          customBits[index] = !customBits[index];
          button.classList.toggle('on', customBits[index]);
          button.setAttribute('aria-pressed', String(customBits[index]));
        },
        { signal }
      );

      lab.querySelector('[data-lab-apply]')?.addEventListener('click', applyCustom, { signal });
      lab.querySelector('[data-lab-clear]')?.addEventListener('click', clearCustom, { signal });

      imageInput?.addEventListener(
        'change',
        async (event) => {
          const file = event.currentTarget.files?.[0];
          if (!file) return;
          try {
            const imageData = await imageFileToImageData(file);
            presetImageData = null;
            uploadedImageData = imageData;
            render();
            refreshScreen();
            announce('Image applied to the 200 × 200 display.');
          } catch (_) {
            announce('This image could not be converted. Please try another file.');
          } finally {
            event.currentTarget.value = '';
          }
        },
        { signal }
      );

      // 事件：心情滑块（选择展示的情绪图标，不测量用户情绪）
      moodRange?.addEventListener(
        'input',
        (event) => {
          const value = Number(event.currentTarget.value);
          const pattern = moodPatternForValue(value);
          if (!pattern) return;
          if (moodName) moodName.textContent = pattern.title;
          if (pattern.id !== currentId || customBits || uploadedImageData) choosePattern(pattern.id);
        },
        { signal }
      );

      // Theme Editor：选中本 section 时收起绘制面板，避免遮挡编辑
      const isOwnEvent = (event) => root === event.target || root.contains(event.target);
      const onSelect = (event) => {
        if (isOwnEvent(event)) details?.removeAttribute('open');
      };
      document.addEventListener('shopify:section:select', onSelect, { signal });
      document.addEventListener('shopify:block:select', onSelect, { signal });

      choosePattern(currentId);
      mounted.add(root);

      // unmount：section 卸载时彻底清理监听器（target 为 section 根元素）
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target !== root) return;
        controller.abort();
        mounted.delete(root);
      }, { signal });
    };

    const roots = document.querySelectorAll('.primitra-eink-lab-section');
    roots.forEach(mountLab);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches?.('.primitra-eink-lab-section')) mountLab(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primitra-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const header = document.querySelector('.primitra-header');
    const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');

    if (!header || !mobileMenuToggle || !mobileMenu) return;

    // Sticky header 滚动处理
    if (header.classList.contains('primitra-header--sticky')) {
      const handleScroll = () => {
        const isScrolled = window.scrollY > 10;
        header.classList.toggle('is-scrolled', isScrolled);
      };

      window.addEventListener('scroll', Primitra.throttle(handleScroll, 100));
    }

    // Mobile menu toggle
    mobileMenuToggle.addEventListener('click', () => {
      const isOpen = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
      mobileMenuToggle.setAttribute('aria-expanded', !isOpen);
      mobileMenu.classList.toggle('is-open', !isOpen);
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Close mobile menu on link click
    const mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Close mobile menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
        mobileMenuToggle.focus();
      }
    });

    // Theme Editor support
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(header)) {
        // 重新初始化header
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primitra-product-eink-display"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new WeakSet();
    const mount = (root) => {
      if (!root || mounted.has(root)) return;
      const preview = root.querySelector('[data-product-eink-preview]');
      const title = root.querySelector('[data-product-eink-title]');
      const description = root.querySelector('[data-product-eink-description]');
      const functions = root.querySelectorAll('[data-product-eink-function]');
      if (!preview || !functions.length) return;
      const controller = new AbortController();
      functions.forEach((item) => item.addEventListener('click', () => {
        preview.src = item.dataset.screen || preview.src;
        if (title) title.textContent = item.dataset.title || '';
        if (description) description.textContent = item.dataset.description || '';
        functions.forEach((button) => { const selected = button === item; button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected)); });
      }, { signal: controller.signal }));
      document.addEventListener('shopify:section:unload', (event) => { if (event.target === root) { controller.abort(); mounted.delete(root); } }, { signal: controller.signal });
      mounted.add(root);
    };
    const mountAll = (scope = document) => scope.querySelectorAll('[data-product-eink-display]').forEach(mount);
    document.addEventListener('DOMContentLoaded', () => mountAll());
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
